import {useIsGuestSession} from '@sollapay/web-core';

import {useTrustAccountMembersQuery} from '@/features/trust-accounts/members';

import {useTrustAccountGuestsQuery} from './useTrustAccountGuestsQueries';

/**
 * The Share button's data, started together; a page can call it early to load ahead of the button.
 * A guest never reads the firm-only roster.
 */
export function useShareButtonQueries(trustAccountId: string) {
  const isGuest = useIsGuestSession();
  const {data: roster, isPending} = useTrustAccountMembersQuery(trustAccountId, {
    enabled: !isGuest
  });
  useTrustAccountGuestsQuery(trustAccountId, {enabled: !isGuest});
  // A disabled query stays pending and keeps any cached roster, so answer for a guest outright.
  if (isGuest) return {roster: undefined, isRosterPending: false};
  return {roster, isRosterPending: isPending};
}
